import { Box, Breadcrumbs, Card, CardContent, CardMedia, CircularProgress, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap';
// import AmbeintTempTab from './ambientTabContent/AmbeintTempTab';
import TabContent from '../../../../../components/TabContent';
import { WmcContext } from '../../../../../context/WmcContext';
// import { DATA_TYPE, DT1, DT2, LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY } from '../../../../../api/AxiosApi';
import WmsTab3TabContent from '../../../../../components/WMS/WmsTab3TabContent';
import { getDateTimeForTab3, getGraphTab3DateTime } from '../../../../../utils';
import { AuthenticationContext } from '../../../../../context/AuthenticationContext';

function TransformerHealthTab3() {
    const { spacing, breakpoints, palette } = useTheme()
    const { getWmSENS, MenuLoadingTrans, getWmSENSTab3Data, WmcSensTab3Data, getWmcDash, WmcDashTab3Data, getWmcDashTab3, getTabWmcMenuTransForm, MenuItemsTrans,MenuItems2Trans } = useContext(WmcContext)
    const lgs = useMediaQuery(breakpoints.up('lg'))
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const [FromDate, setFromDate] = useState(getDateTimeForTab3().LastDay)
    const [ToDate, setToDate] = useState(getDateTimeForTab3().Today)
    const LOGIN_ID = localStorage.getItem('LoginID')
    const LOC_CODE = localStorage.getItem('LCODE')
    // const LOGIN_ID = 2302069
    const PASS_KEY = "xyz"
    const PASS_KEY1 = "WERRRRRRRRRRR"
    const WEB_KEY = "WEBXYZ321"
    const DATA_TYPE = "0"
    const DATA_TYPE1 = "1"

    const [key, setKey] = useState('');
    const DTYPE = "TRN";

    useEffect(() => {
        // Set the activeKey to the ID of the first item in PvMnMenuData
        if (MenuItemsTrans && MenuItemsTrans?.length > 0) {
            setKey(MenuItemsTrans[0]?.MENU_ID);
        }
    }, [MenuItemsTrans]);

    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }
    const WM_TYPE = key

    useEffect(() => {
        getTabWmcMenuTransForm(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY,DTYPE)
    }, [])

    useEffect(() => {
        getWmSENSTab3Data(LOC_CODE, LOGIN_ID, PASS_KEY1, WEB_KEY, WM_TYPE, FromDate, ToDate)
    }, [key])

    useEffect(() => {
        getWmcDashTab3(LOC_CODE, LOGIN_ID, PASS_KEY1, WEB_KEY, WM_TYPE, DATA_TYPE, FromDate, ToDate)
    }, [key])

    useEffect(() => {
        getWmcDash(LOC_CODE, LOGIN_ID, PASS_KEY1, WEB_KEY, WM_TYPE, DATA_TYPE1, FromDate, ToDate)
    }, [key])

    return (
        <>
            <CssBaseline />
            <Box mt={spacing(1)}>


                {
                    MenuItemsTrans?.length > 0 ?
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                        >
                            {
                                MenuLoadingTrans ? <CircularProgress /> : MenuItemsTrans?.length > 0 ? MenuItemsTrans?.map((item, index) => {
                                    const matchedMenuItem = MenuItems2Trans.find(menuItem => menuItem?.MENU_NAME === item?.MENU_NAME);
                                    return (
                                        <Tab key={index} eventKey={item?.MENU_ID} title={item?.MENU_NAME}>
                                            <WmsTab3TabContent WM_TYPE={WM_TYPE} tabTitle={item?.MENU_NAME} menuID={item?.MENU_ID} menuItem={matchedMenuItem?.SH_NAME_LOG || ''} />
                                        </Tab>
                                    )
                                }) : <Typography>Menu not found</Typography>
                            }
                        </Tabs>
                        : <Typography variant='body2' width={'100%'} textAlign={'center'}>Data not found</Typography>

                }



            </Box>
        </>
    )
}

export default TransformerHealthTab3
